import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import {
	TEuDdpCreateDeliveryOperatorRequest,
	TEuDdpCreatePricingPlanRequest,
	TEuDdpCreateTariffRequest,
	TEuDdpDeliveryOperatorSearchRequest,
	TEuDdpRecordSearchRequest,
	TEuDdpPricingPlanSearchRequest,
	TEuDdpTariffSearchRequest,
	TEuDdpUpdateDeliveryOperatorRequest,
	TEuDdpUpdatePricingPlanRequest,
	TEuDdpUpdateTariffRequest,
	TEuDdpOrderSearchRequest,
	TEuDdpOrderDetailsRequest,
} from 'redux/reducers/euDdp/types';
import { TEuDdpApi } from './types';

export const euDdp: TEuDdpApi = {
	searchDeliveryOperators: (payload: TEuDdpDeliveryOperatorSearchRequest) =>
		http.post(endpoint.euDdp.SEARCH_DELIVERY_OPERATORS, payload).then((response) => response.data),
	createDeliveryOperator: (payload: TEuDdpCreateDeliveryOperatorRequest) =>
		http.post(endpoint.euDdp.CREATE_DELIVERY_OPERATOR, payload).then((response) => response.data),
	updateDeliveryOperator: (payload: TEuDdpUpdateDeliveryOperatorRequest) =>
		http
			.put(endpoint.euDdp.UPDATE_DELIVERY_OPERATOR(payload.id), payload.body)
			.then((response) => response.data),
	searchTariffs: (payload: TEuDdpTariffSearchRequest) =>
		http.post(endpoint.euDdp.SEARCH_TARIFFS, payload).then((response) => response.data),
	createTariff: (payload: TEuDdpCreateTariffRequest) =>
		http.post(endpoint.euDdp.CREATE_TARIFF, payload).then((response) => response.data),
	updateTariff: (payload: TEuDdpUpdateTariffRequest) =>
		http
			.put(endpoint.euDdp.UPDATE_TARIFF(payload.id), payload.body)
			.then((response) => response.data),
	searchPricingPlans: (payload: TEuDdpPricingPlanSearchRequest) =>
		http.post(endpoint.euDdp.SEARCH_PRICING_PLANS, payload).then((response) => response.data),
	createPricingPlan: (payload: TEuDdpCreatePricingPlanRequest) =>
		http.post(endpoint.euDdp.CREATE_PRICING_PLAN, payload).then((response) => response.data),
	updatePricingPlan: (payload: TEuDdpUpdatePricingPlanRequest) =>
		http
			.put(endpoint.euDdp.UPDATE_PRICING_PLAN(payload.id), payload.body)
			.then((response) => response.data),
	searchEuDdpRecords: (payload: TEuDdpRecordSearchRequest) =>
		http.post(endpoint.euDdp.SEARCH_RECORDS, payload).then((response) => response.data),
	searchOrders: (payload: TEuDdpOrderSearchRequest) =>
		http.post(endpoint.euDdp.SEARCH_ORDERS, payload).then((response) => response.data),
	getOrderDetails: (payload: TEuDdpOrderDetailsRequest) =>
		http.get(endpoint.euDdp.GET_ORDER(payload.orderId)).then((response) => response.data),
	getPrintLabels: () => http.get(endpoint.euDdp.PRINT_LABELS).then((response) => response.data),
	getOmnivaLabel: (orderId: number) =>
		http
			.get(endpoint.euDdp.GET_OMNIVA_LABEL(orderId), { responseType: 'blob' })
			.then((response) => response.data),
	getInvoiceProforma: (orderId: number) =>
		http
			.get(endpoint.euDdp.GET_INVOICE_PROFORMA(orderId), { responseType: 'blob' })
			.then((response) => response.data),
};
